import { render, staticRenderFns } from "./lawyer.vue?vue&type=template&id=c949a1f2&scoped=true&"
import script from "./lawyer.vue?vue&type=script&lang=js&"
export * from "./lawyer.vue?vue&type=script&lang=js&"
import style0 from "./lawyer.vue?vue&type=style&index=0&id=c949a1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c949a1f2",
  null
  
)

export default component.exports